<div
  class="verify-page page-wrapper page-wrapper--fullscreen-min page-wrapper--column"
>
  <div class="verify-form__wrapper">
    <div class="finished">
      <fa-icon [icon]="_iconFinished" class="finished__icon"></fa-icon>
      <div class="finished__title">{{ 'thank_you' | translate }}</div>
      <span>{{ 'verify_finished' | translate }}</span>
    </div>
  </div>
</div>
